/* eslint-disable radix */
// Dependecies
import { useState } from 'react';
import { reject } from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
// Store
import user from '../../store/user';

// Hooks
import useAlert from '../useAlert';
import useLanguage from '../useLanguage';

function useReport() {
  const { alertUpdate, messageError, setAlertUpdate, setMessageError } = useAlert();
  const [userStore] = user();
  const { t } = useTranslation('report');
  const [isCompleted, setIsCompleted] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalErrorDate, setModalErrorDate] = useState(false);
  const [dateCalendar, useSetDateCalendar] = useState();
  const [dateCalendarEnd, useSetDateCalendarEnd] = useState();
  const [typeExcel, useSetTypeExcel] = useState(0);
  const types = [t('maintenance-requests'), t('vehicles'), t('plans')];
  const { locale } = useLanguage();

  const onPanelChange = (value) => {
    useSetDateCalendar(`${moment(value).format('YYYY-MM-DD')} 00:00:00`);
  };

  const onPanelChange2 = (value) => {
    useSetDateCalendarEnd(`${moment(value).format('YYYY-MM-DD')} 23:00:00`);
  };

  const onSubmit = async (data) => {
    try {
      const jsons = {
        date: dateCalendar,
        dateEnd: dateCalendarEnd,
        data,
      };

      const options = {
        method: 'POST',
        body: JSON.stringify(jsons),
        responseType: 'blob', // important
        headers: {
          'Content-Type': 'application/json',
          Authorization: `bearer ${userStore.token}`,
        },
      };

      const response = await fetch(
        `/api/bread/jwt/services/static/download_report?lang=${locale}`,
        options
      );
      const res = await response.json();
      if (response.status !== 200) {
        if (response.status === 401) {
          setMessageError(true);
        }
      } else if (res.data.length <= 3) {
        setModalErrorDate(true);
      } else {
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: 'octet/strea;charset=utf-8' })
        );
        const link = document.createElement('a');
        link.href = url;
        const name = parseInt(data.type) - 1;
        link.setAttribute('download', `${types[name]}.csv`);
        document.body.appendChild(link);
        link.click();
        useSetTypeExcel(0);
        setAlertUpdate(true);
      }
    } catch (e) {
      reject();
    }
  };

  const closeModal = () => {
    setModalError(false);
    setModalErrorDate(false);
  };

  return {
    alertUpdate,
    messageError,
    onSubmit,
    isCompleted,
    setIsCompleted,
    modalError,
    modalErrorDate,
    closeModal,
    onPanelChange,
    onPanelChange2,
    useSetTypeExcel,
    typeExcel,
  };
}

export default useReport;
